import * as React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  productsById$,
  currentProductId$,
} from '../../selectors/product';

import * as ProductActions from '../../actions/product';
import * as ProductCreators from '../../creators/product';

import State from '../../interfaces/states/State';
import ProductById from '../../interfaces/ProductById';

import './style.scss';

interface DispatchProps {
  receiveProductAction: (value: number) => void;
  product: () => void;
}

interface OwnProps {
  currentProductId: number;
  productsById: ProductById[];
}

interface Props extends DispatchProps, OwnProps {}

function ProductList (props: Props) {

  const {
    receiveProductAction,
    product,
    currentProductId,
    productsById,
  } = props;

  const history = useHistory();

  const receiveProduct = (e) => {
    receiveProductAction(Number(e.target.value));
    history.replace(`?product=${e.target.value}`);
    product();
  };

  return (
    <fieldset className='product-fieldset'>
      <legend className='product-legend'>
        {'Product'}
      </legend>
      <select
        onChange={receiveProduct}
        className='product-select'
        value={currentProductId}>
        {
          productsById.map((product, key) => {
            return (
              <option
                key={key}
                value={product.id}>
                {product.label}
              </option>
            );
          })
        }
      </select>
    </fieldset>
  );
}

const mapStateToProps = (state: State) => {
  return {
    currentProductId: currentProductId$(state),
    productsById: productsById$(state),
  };
};

const mergeProps = (stateProps, dispatchProps, props) => {
  return {
    ...stateProps,
    receiveProductAction: dispatchProps.receiveProductAction,
    product: dispatchProps.product,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    receiveProductAction: ProductActions.fetchReceiveProductAction,
    product: ProductCreators.product,
  }, mergeProps
)(React.memo(ProductList));
